<template>
    <div class="">
      <!-- img tag를 이용한 일반적인 Image 생성. -->
      <header class="">
      </header>
      <!-- v-viewer를 이용한 Image 생성. -->
      <viewer :images="images" :options="options" @inited="inited">
        <img v-img-orientation-changer v-for="image in images" :src="image" :key="image" class="hide" />
      </viewer>
      
      <!-- Methods -->
    </div>
</template>

<script>
  import { nameByConstMixin } from '@/lib/mixins'

  export default {
    mixins: [nameByConstMixin],
    name: 'image_viewer',
    prop: ['consult_id'],
    data () {
      return {
        images: [],
        idx: 0,
        options: {
          title: 0,
          fullscreen: false,
          backdrop: false,
          //inline: true,
          button: false,
          navbar: false,
          toolbar: {
            zoomIn: 1,
            zoomOut: 1,
            oneToOne: 0,
            prev: 0,
            play: 0,
            next: 0,
            rotateLeft: 1,
            reset: 1,
            rotateRight: 1,
            flipHorizontal: 1,
            flipVertical: 1,
          },
        }
      }
    },
    methods: {
      inited(viewer) {
        this.$viewer = viewer;

      },
      view(idx) {
        this.$viewer.view(idx);
      },
      show() {
        this.$viewer.show();
      },
      async getImage(consult_id) {
        let { data } = await this.axios.get(`consult/${consult_id}`)
        let { resp } = data

        //let path_img =  URLS.API;
        let path_img =  URLS.S3_APP;

        this.images = []
        if(resp.img_url1!=null) {
          if(resp.img_url1) this.images.push(path_img+resp.img_url1.substring(1));
          if(resp.img_url2) this.images.push(path_img+resp.img_url2.substring(1));
          if(resp.img_url3) this.images.push(path_img+resp.img_url3.substring(1));
        }
      },
      printElement(elementRef) {
        let app = document.getElementById('app') 
        const printContents = elementRef.innerHTML 
        let printDiv = document.createElement('DIV') 
        document.body.appendChild(printDiv) 
        printDiv.innerHTML = printContents 
        app.style.display = 'none' 
        window.print() 
        app.style.display = 'block' 
        printDiv.style.display = 'none' 
        printDiv.innerHTML = ''
      },
    },
    async mounted() {
      // console.log('query', this.$route.query.image_url);
      this.images = [];
      if(this.$route.query) {
        // console.log('ok', this.$route.query.image_url);
        //await this.getImage(this.consult_id);
        this.images.push(this.$route.query.image_url);
        this.show();
      } 
    },
    watch: {
       '$route' : function (to, from) {
        // console.log('imgViewer route 변경됨(watch)', to.query)
        this.images = [];
        this.images.push(to.query.image_url);
        this.show();
       },
    },
  }
</script>

<style scoped>

  .gallary_image {
    width: 180px;
    height: 180px;
    display: inline;
    margin: 2px 2px;
    cursor: pointer;
  }
  .hide {
    display: none;
  }
  header {
    height: 120px;
  }

</style>